import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-electricityMarketDataCenter_closeImport",
  "use": "icon-electricityMarketDataCenter_closeImport-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-electricityMarketDataCenter_closeImport\"><defs></defs><path class=\"a\" d=\"M150.245,145.949,156.192,140a.616.616,0,0,0-.872-.871l-5.947,5.948-5.948-5.949a.616.616,0,1,0-.872.871l5.948,5.948-5.948,5.948a.616.616,0,0,0,.872.871l5.948-5.948,5.947,5.948a.616.616,0,0,0,.872-.871Z\" transform=\"translate(-142.373 -138.949)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol